import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../_services/api/axios';
import withErrorHandler from '../_hoc/withErrorHandler';
import * as actionCreators from '../_store/actions/index';

import { 
    Loading
  } from 'components'

import App from 'components/App';

class RestoreToken extends Component {
    componentDidMount() {
        this.props.tokenRestoreToken(this.props.auth.token, this.props.auth.user_id);
    }

    render() {       
        if(this.props.tokenRestore.isRestoring) {
            return <Loading/>;
        }
        
        if(this.props.tokenRestore.successful) {
            return <App/>
        }

        if(this.props.tokenRestore.failed) {
            window.location.href = `${process.env.REACT_APP_ACCOUNT_URL}?redirectTo=${process.env.REACT_APP_APP_URL}`;
        }      

        return null;
    }
};

const mapStateToProps = state => {
    return {
        tokenRestore: state.tokenRestore,
        auth: state.auth,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        tokenRestoreToken: (token, user_id) => dispatch(actionCreators.tokenRestoreToken(token, user_id))
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(RestoreToken, axios));


// WEBPACK FOOTER //
// ./src/components/RestoreToken.js